module.exports = __webpack_public_path__ + "img/item-4-1.4c273e46.png";